namespace GeniuzPOS.Inventory {
    export class IcStkmedthodColumns {
        static columnsKey = 'Inventory.IcStkmedthod';
    }
}
